export default "__VITE_ASSET__BecNnDMZ__"